import colors from "assets/theme/base/colors";
import pxToRem from "assets/theme/functions/pxToRem";

const { grey } = colors;

const borders = {
  borderColor: grey[300],
  borderWidth: {
    0: 0,
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },
  borderRadius: {
    xs: pxToRem(4),
    sm: pxToRem(6),
    md: pxToRem(10),
    lg: pxToRem(12),
    xl: pxToRem(16),
    xxl: pxToRem(20),
    full: pxToRem(9999),
    section: pxToRem(160),
  },
};

export default borders;
